import React from 'react'
import MuiDialogTitle from '@mui/material/DialogTitle'
import MuiDialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import { withStyles } from '@mui/styles'
import { Grid } from '@mui/material'

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'row',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
    },
})

export const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Grid container justify="center">
                <Typography variant="h6">{children}</Typography>
            </Grid>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon sx={{color:'grey !important'}} />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    )
})

export const DialogContent = withStyles((theme) => ({
    root: {
        margin: theme.spacing(1),
    },
}))(MuiDialogContent)
